import React, { useContext, useState } from 'react';
import { AuthContext } from '../pages/AuthContext'; // Import AuthContext
import { API_END_POINT } from '../pages/Utils/Constant';
import axios from 'axios';
import { IoEye, IoEyeOff } from "react-icons/io5";
import { Link, useNavigate } from 'react-router-dom';
import CommonNavbar from '../pages/CommonNavbar';
import logoimg from "../assets/rootimg/astrotellerlogo.png";
const Signup = () => {
    const [input, setInput] = useState({
        fullname: '',
        email: '',
        password: '',
        confirmPassword: ''
    });
    const [passwordVisible, setPasswordVisible] = useState({
        password: false,
        confirmPassword: false
    });
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [validationErrors, setValidationErrors] = useState({});
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInput(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const validate = () => {
        const errors = {};

        // Full Name validation
        if (!input.fullname) {
            errors.fullname = "Full name is required.";
        }

        // Email validation
        if (!input.email) {
            errors.email = "Email is required.";
        } else if (!/\S+@\S+\.\S+/.test(input.email)) {
            errors.email = "Please enter a valid email address.";
        }

        // Password validation
        if (!input.password) {
            errors.password = "Password is required.";
        } else if (input.password.length < 6) {
            errors.password = "Password must be at least 6 characters long.";
        }

        // Confirm Password validation
        if (!input.confirmPassword) {
            errors.confirmPassword = "Please confirm your password.";
        } else if (input.password !== input.confirmPassword) {
            errors.confirmPassword = "Passwords do not match.";
        }

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const togglePasswordVisibility = (field) => {
        setPasswordVisible(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const { setIsLogged } = useContext(AuthContext);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage('');

        if (!validate()) {
            setLoading(false);
            return;
        }

        try {
            const response = await axios.post(`${API_END_POINT}auth/signup`, {
                name: input.fullname,
                email: input.email,
                password: input.password
            });

            sessionStorage.setItem('tempEmail', input.email);

            setInput({
                fullname: '',
                email: '',
                password: '',
                confirmPassword: ''
            });

            navigate('/verify-email');

        } catch (error) {
            console.error('Signup error:', error.response?.data || error.message);
            setErrorMessage(error.response?.data?.message || 'An error occurred during signup.');
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-white to-success/40 ">
            <CommonNavbar />
            
            <div className="w-full max-w-md p-8 mt-16 bg-white rounded-lg shadow-lg">
                {/* Logo */}
                <div className="flex justify-center mb-2">
                    <div className="w-[75%] h-auto mx-auto">
                        <img src={logoimg} alt="Logo" className="w-full h-full object-contain" />
                    </div>
                </div>

                {/* Heading */}
                <h1 className="text-lg font-semibold text-center text-secondary">
                    Sign In to See What the Stars Hold
                </h1>
                <p className="text-gray-600 text-center mb-2">
                    Please enter your details
                </p>
                <form onSubmit={handleSubmit}>
                    {/* Full Name Input */}
                    <div className="mb-4">
                        <input
                            type="text"
                            placeholder="Full Name"
                            name="fullname"
                            value={input.fullname}
                            onChange={handleChange}
                            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#6366f1]"
                        />
                        {validationErrors.fullname && (
                            <p className="text-red-500 text-sm mt-1">{validationErrors.fullname}</p>
                        )}
                    </div>

                    {/* Email Input */}
                    <div className="mb-4">
                        <input
                            type="email"
                            placeholder="Email"
                            name="email"
                            value={input.email}
                            onChange={handleChange}
                            className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#6366f1]"
                        />
                        {validationErrors.email && (
                            <p className="text-red-500 text-sm mt-1">{validationErrors.email}</p>
                        )}
                    </div>

                    {/* Password Input */}
                    <div className="mb-4 relative">
                        <div className="relative">
                            <input
                                type={passwordVisible.password ? "text" : "password"}
                                placeholder="Password"
                                name="password"
                                value={input.password}
                                onChange={handleChange}
                                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#6366f1]"
                            />
                            <button
                                type="button"
                                className="absolute right-3 top-1/2 transform -translate-y-1/2"
                                onClick={() => togglePasswordVisibility("password")}
                            >
                                {passwordVisible.password ? <IoEye size={20} color="#6B7280" /> : <IoEyeOff size={20} color="#6B7280" />}
                            </button>
                        </div>
                        {validationErrors.password && (
                            <p className="text-red-500 text-sm mt-1">{validationErrors.password}</p>
                        )}
                    </div>

                    {/* Confirm Password Input */}
                    <div className="mb-6 relative">
                        <div className="relative">
                            <input
                                type={passwordVisible.confirmPassword ? "text" : "password"}
                                placeholder="Confirm Password"
                                name="confirmPassword"
                                value={input.confirmPassword}
                                onChange={handleChange}
                                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#6366f1]"
                            />
                            <button
                                type="button"
                                className="absolute right-3 top-1/2 transform -translate-y-1/2"
                                onClick={() => togglePasswordVisibility("confirmPassword")}
                            >
                                {passwordVisible.confirmPassword ? <IoEye size={20} color="#6B7280" /> : <IoEyeOff size={20} color="#6B7280" />}
                            </button>
                        </div>
                        {validationErrors.confirmPassword && (
                            <p className="text-red-500 text-sm mt-1">{validationErrors.confirmPassword}</p>
                        )}
                    </div>

                    {/* Error Message */}
                    {errorMessage && (
                        <p className="text-red-500 text-center mb-4">{errorMessage}</p>
                    )}

                    {/* Sign Up Button */}
                    <button
                        type="submit"
                        className="w-full bg-black text-white py-3 rounded-md font-medium hover:bg-secondary transition-colors"
                        disabled={loading}
                    >
                        {loading ? "Creating Account..." : "Sign Up"}
                    </button>

                    {/* Login Link */}
                    <p className="text-gray-600 text-center mt-6">
                        Already have an account?{" "}
                        <Link to="/login" className="text-blue-500 font-medium">
                            Login
                        </Link>
                    </p>
                </form>
            </div>
        </div>
    );
};

export default Signup;
